import { alert } from './stores/alert'
import { loading } from './stores/loading'
import { translate } from './i18n'

let cacheLibraries
let cacheRestServer

/**
 * @returns {Promise<Object>} Library connection data
 */
const libraries = async () => {
    if (!cacheLibraries) {
        loading.newLoading();
        try {
            cacheLibraries = (await (await fetch('/api.json')).json()).library
        }
        catch (e) {
            alert.newAlert({ message: translate('alerts_errors_notLoadLibraryData'), type: 'error' })
        }
        finally {
            loading.removeLoading()
        }
    }
    return cacheLibraries;
}

/**
 * 
 * @returns {Promise<Object>} The url of the rest server
 */
const restServer = async () => {

    if (!cacheRestServer) {
        loading.newLoading()
        try {
            cacheRestServer = (await (await fetch('/api.json')).json()).restServer
        } catch (err) {
            alert.newAlert({ message: translate('alerts_errors_notLoadUrl'), type: 'error' })
        } finally {
            loading.removeLoading()
        }
    }
    return cacheRestServer
}

const promiseRestServer = restServer()

const promiseLibraries = libraries()

const getMethod = async endPoint => (await promiseRestServer)[endPoint].method

/**
 * 
 * @param {string} endPoint - The endPoint of the rest server
 * @param {Object} [params] - The params that replace :param in the url
 * @returns {Promise<[string,string,string]>} The required url
 */
const getUrl = async (endPoint, params = {}) => {
    const method = await getMethod(endPoint);
    let url = '/' + (await promiseRestServer).location + (await promiseRestServer)[endPoint].endpoint;
    const requestParams = {};
    Object.keys(params).forEach(param => {
        const re = new RegExp(':' + param, 'i');
        if (re.test(url)) {
            url = url.replace(re, params[param]);
        }
        else {
            requestParams[param] = params[param];
        }
    });

    if (/get/i.test(method) && Object.keys(requestParams).length > 0) {
        url += '?' + Object.entries(requestParams).map(e => e[0] + '=' + e[1]).join('&');
    }

    return [url,method,requestParams];
}




export { getUrl, getMethod, promiseLibraries }